<template>
  <LoadingData v-if="loadData" />
  <div v-if="metas.length > 0">
    <div class="card">
      <div class="table-responsive table-scrollable">
        <table class="table table-sm table-bordered">
          <thead class="text-center">
            <tr>
              <th
                class="position-sticky start-0 top-0 bg-dark text-white fs-smxs"
              >
                Centro de Custo
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                Meta
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                Valor Orçado
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                Valor Realizado
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                1º Trimestre
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                2º Trimestre
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                3º Trimestre
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                4º Trimestre
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(meta, index) in metas" :key="index">
              <td class="position-sticky start-0 fs-smxs">
                {{ meta.codCCustoFilho }} -
                {{ meta.nomeCCustoFilho }}
              </td>
              <td class="fs-smxs">{{ meta.codMeta }} - {{ meta.nome }}</td>
              <td class="fs-smxs text-center">
                <input
                  class="form-control text-center"
                  :value="moneyToCurrencyBr(meta.valorProposta)"
                  disabled
                />
              </td>
              <td class="fs-smxs text-center">
                <input
                  class="form-control text-center"
                  :value="moneyToCurrencyBr(meta.valorReformulacao)"
                  disabled
                />
              </td>
              <td class="fs-smxs text-center">
                <div class="input-group input-group-sm">
                  <input
                    type="number"
                    class="form-control form-control-number text-center"
                    @input="createUpdateMeta({ ...meta })"
                    v-model="meta.primeiroTrimestre"
                    :disabled="orcamentoPropostaOrReformulacaoIsClosed"
                  />
                  <span
                    class="input-group-text cursor-pointer p-0"
                    title="Exibir Memória de Cálculo"
                    @click="
                      showMemoriaCalculo({
                        codMeta: meta.codMeta,
                        codCCustoFilho: meta.codCCustoFilho,
                        trimestre: 1,
                        hide: meta.showMemoriaCalculoPrimeiroTrimestre,
                      })
                    "
                  >
                    <i class="ph-calculator text-success" />
                  </span>
                </div>
                <div
                  v-if="meta.showMemoriaCalculoPrimeiroTrimestre"
                  class="mt-2"
                  ref="textarea"
                >
                  <textarea
                    class="form-control textarea-custom"
                    @input="createUpdateMeta({ ...meta })"
                    @keypress="resizeTextArea"
                    v-model="meta.memoraCalculoPrimeiroTrimestre"
                    :disabled="orcamentoPropostaOrReformulacaoIsClosed"
                  />
                </div>
              </td>
              <td class="fs-smxs text-center">
                <div class="input-group input-group-sm">
                  <input
                    type="number"
                    class="form-control form-control-number text-center"
                    @input="createUpdateMeta({ ...meta })"
                    v-model="meta.segundoTrimestre"
                    :disabled="orcamentoPropostaOrReformulacaoIsClosed"
                  />
                  <span
                    class="input-group-text cursor-pointer p-0"
                    title="Exibir Memória de Cálculo"
                    @click="
                      showMemoriaCalculo({
                        codMeta: meta.codMeta,
                        codCCustoFilho: meta.codCCustoFilho,
                        trimestre: 2,
                        hide: meta.showMemoriaCalculoSegundoTrimestre,
                      })
                    "
                  >
                    <i class="ph-calculator text-success" />
                  </span>
                </div>
                <div
                  v-if="meta.showMemoriaCalculoSegundoTrimestre"
                  class="mt-2"
                  ref="textarea"
                >
                  <textarea
                    class="form-control textarea-custom"
                    @input="createUpdateMeta({ ...meta })"
                    @keypress="resizeTextArea"
                    v-model="meta.memoraCalculoSegundoTrimestre"
                    :disabled="orcamentoPropostaOrReformulacaoIsClosed"
                  />
                </div>
              </td>
              <td class="fs-smxs text-center">
                <div class="input-group input-group-sm">
                  <input
                    type="number"
                    class="form-control form-control-number text-center"
                    @input="createUpdateMeta({ ...meta })"
                    v-model="meta.terceiroTrimestre"
                    :disabled="orcamentoPropostaOrReformulacaoIsClosed"
                  />
                  <span
                    class="input-group-text cursor-pointer p-0"
                    title="Exibir Memória de Cálculo"
                    @click="
                      showMemoriaCalculo({
                        codMeta: meta.codMeta,
                        codCCustoFilho: meta.codCCustoFilho,
                        trimestre: 3,
                        hide: meta.showMemoriaCalculoTerceiroTrimestre,
                      })
                    "
                  >
                    <i class="ph-calculator text-success" />
                  </span>
                </div>
                <div
                  v-if="meta.showMemoriaCalculoTerceiroTrimestre"
                  class="mt-2"
                  ref="textarea"
                >
                  <textarea
                    class="form-control textarea-custom"
                    @input="createUpdateMeta({ ...meta })"
                    @keypress="resizeTextArea"
                    v-model="meta.memoraCalculoTerceiroTrimestre"
                    :disabled="orcamentoPropostaOrReformulacaoIsClosed"
                  />
                </div>
              </td>
              <td class="fs-smxs text-center">
                <div class="input-group input-group-sm">
                  <input
                    type="number"
                    class="form-control form-control-number text-center"
                    @input="createUpdateMeta({ ...meta })"
                    v-model="meta.quartoTrimestre"
                    :disabled="orcamentoPropostaOrReformulacaoIsClosed"
                  />
                  <span
                    class="input-group-text cursor-pointer p-0"
                    title="Exibir Memória de Cálculo"
                    @click="
                      showMemoriaCalculo({
                        codMeta: meta.codMeta,
                        codCCustoFilho: meta.codCCustoFilho,
                        trimestre: 3,
                        hide: meta.showMemoriaCalculoQuartoTrimestre,
                      })
                    "
                  >
                    <i class="ph-calculator text-success" />
                  </span>
                </div>
                <div
                  v-if="meta.showMemoriaCalculoQuartoTrimestre"
                  class="mt-2"
                  ref="textarea"
                >
                  <textarea
                    class="form-control textarea-custom"
                    @input="createUpdateMeta({ ...meta })"
                    @keypress="resizeTextArea"
                    v-model="meta.memoraCalculoQuartoTrimestre"
                    :disabled="orcamentoPropostaOrReformulacaoIsClosed"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import { mapGetters } from 'vuex'
import { moneyToCurrencyBr } from '@/utils/strings'
import { debounce } from 'lodash'
import PeriodoAtivoEnum from '@/enum/periodoAtivoEnum'

export default {
  name: 'MetasResult',

  components: {
    LoadingData,
  },

  props: {
    searchData: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
  },

  emits: ['searchData'],

  data() {
    return {
      metas: [],
      loadData: false,
      memoriaCalculoTrimestres: {
        1: 'memoriaCalculoPrimeiroTrimestre',
        2: 'memoriaCalculoSegundoTrimestre',
        3: 'memoriaCalculoTerceiroTrimestre',
        4: 'memoriaCalculoQuartoTrimestre',
      },
      moneyToCurrencyBr,
    }
  },

  computed: {
    ...mapGetters(['orcamentoSelecionado']),

    periodoOrcamentoProposta() {
      return (
        this.orcamentoSelecionado.periodoOrcamento === PeriodoAtivoEnum.PROPOSTA
      )
    },

    periodoOrcamentoReformulacao() {
      return (
        this.orcamentoSelecionado.periodoOrcamento ===
        PeriodoAtivoEnum.REFORMULACAO
      )
    },

    filterPeriodoOrcamentoProposta() {
      return Number(this.filters.periodoOrcamento) === PeriodoAtivoEnum.PROPOSTA
    },

    filterPeriodoOrcamentoReformulacao() {
      return (
        Number(this.filters.periodoOrcamento) === PeriodoAtivoEnum.REFORMULACAO
      )
    },

    orcamentoPropostaOrReformulacaoIsClosed() {
      return (
        (this.periodoOrcamentoProposta &&
          this.filterPeriodoOrcamentoReformulacao) ||
        (this.periodoOrcamentoReformulacao &&
          this.filterPeriodoOrcamentoProposta) ||
        (!this.periodoOrcamentoProposta && !this.periodoOrcamentoReformulacao)
      )
    },
  },

  watch: {
    searchData: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.search()
        }
      },
      immediate: true,
    },
    filters: {
      handler(newVal, oldVal) {
        if (
          newVal.codCCustoPai &&
          newVal.orcamentoId &&
          newVal.periodoOrcamento &&
          !this.searchData
        ) {
          this.metas = []
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    async search() {
      try {
        this.loadData = true
        this.metas = []

        this.metas = await this.$store.dispatch('getMetas', this.filters)

        this.$emit('searchData', false)
        this.loadData = false
      } catch (error) {
        this.$emit('searchData', false)
        this.loadData = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async createUpdateMeta(meta) {
      try {
        const response = await this.$store.dispatch('saveUpdateMeta', {
          codCCustoPai: this.filters.codCCustoPai,
          orcamentoId: this.filters.orcamentoId,
          meta: {
            codCCustoFilho: meta.codCCustoFilho,
            codSistego: meta.codSistego,
            codMeta: meta.codMeta,
            nome: meta.nome,
            primeiroTrimestre: meta.primeiroTrimestre,
            memoraCalculoPrimeiroTrimestre: meta.memoraCalculoPrimeiroTrimestre,
            segundoTrimestre: meta.segundoTrimestre,
            memoraCalculoSegundoTrimestre: meta.memoraCalculoSegundoTrimestre,
            terceiroTrimestre: meta.terceiroTrimestre,
            memoraCalculoTerceiroTrimestre: meta.memoraCalculoTerceiroTrimestre,
            quartoTrimestre: meta.quartoTrimestre,
            memoraCalculoQuartoTrimestre: meta.memoraCalculoQuartoTrimestre,
          },
        })

        this.$root.$refs.notification.success(response.message)
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    showMemoriaCalculo(params) {
      this.metas = this.metas.map((meta) => {
        if (
          meta.codMeta === params.codMeta &&
          meta.codCCustoFilho === params.codCCustoFilho
        ) {
          const trimestreSelected =
            this.memoriaCalculoTrimestres[params.trimestre]
          const showTrimestre = `show${
            trimestreSelected.charAt(0).toUpperCase() +
            trimestreSelected.slice(1)
          }`

          return {
            ...meta,
            [showTrimestre]: !meta[showTrimestre],
            [trimestreSelected]: meta.trimestreSelected,
          }
        }
        return { ...meta }
      })

      if (!params.hide) {
        this.$nextTick(() => {
          this.$refs.textarea.forEach((ta) => {
            ta.firstChild.dispatchEvent(new Event('keypress'))
          })
        })
      }
    },

    resizeTextArea(event) {
      const element = event.target
      element.style.height = '18px'
      element.style.height = `${element.scrollHeight + 2}px`
    },
  },

  mounted() {
    this.createUpdateMeta = debounce(this.createUpdateMeta, 400)
  },
}
</script>

<style scoped>
th.position-sticky.start-0.top-0 {
  min-width: 15rem;
  z-index: 2;
}

th {
  min-width: 8rem;
}

td.position-sticky,
th.position-sticky {
  z-index: 1;
}

td.position-sticky {
  background-color: #f1f1f7;
}

td {
  background-color: #f6f6f6;
  padding: 0.5rem 0.3rem;
}

.form-control {
  padding: 0.35rem;
  font-size: 0.7rem;
  line-height: 1;
}

input:disabled {
  background-color: #e9ecef;
}

.textarea-custom {
  font-size: 0.8rem;
  line-height: 1.2;
}
</style>
